import { RESET } from '../actionTypes';
import { reportTemplateActions } from '../reducer';

export default () => (dispatch) => dispatch(reportTemplateActions[RESET]());
